import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environment';

/**
 * Security interceptor that adds CSRF protection and security headers to API requests.
 * This interceptor:
 * 1. Adds CSRF token to mutating requests (POST, PUT, DELETE, PATCH)
 * 2. Adds security headers to requests
 */
export const securityInterceptor: HttpInterceptorFn = (req, next) => {
  // Only apply to API requests to our backend
  if (req.url.startsWith(environment.baseUrl)) {
    let secureReq = req;

    // Clone the request to add the CSRF token for mutating requests
    const method = req.method.toUpperCase();
    if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
      // Get CSRF token from cookie
      const csrfToken = getCsrfTokenFromCookie();
      if (csrfToken) {
        secureReq = secureReq.clone({
          headers: secureReq.headers.set('X-CSRF-TOKEN', csrfToken)
        });
      }
    }

    // Add security headers to the request
    secureReq = secureReq.clone({
      headers: secureReq.headers
        .set('X-Requested-With', 'XMLHttpRequest') // Helps prevent CSRF
    });

    return next(secureReq);
  }

  return next(req);
};

/**
 * Helper function to get the CSRF token from cookies
 */
function getCsrfTokenFromCookie(): string | null {
  const csrfCookieName = environment.security?.csrfCookieName || 'XSRF-TOKEN';
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === csrfCookieName) {
      return value;
    }
  }
  return null;
}
